import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { connectionsRequest } from 'features/connections'
import { DuplicateMapType } from 'features/maps/types'
import { UserRole } from 'features/users'
import { useMeUser } from 'features/users/hooks/useMeUser'
import { getRoleInfo } from 'features/users/model/user'
import { useEffect, useMemo } from 'react'

export default function useDuplicateMap() {
  const user = useMeUser()
  const isGuest = getRoleInfo(user).role === UserRole.Guest
  const dispatch = useAppDispatch()
  const connectionsStatus = useAppSelector((state) => state.connections.myConnectionsStatus)
  const duplicatingMapId = useAppSelector((state) => state.maps.duplicatingMapId)
  const duplicateMapType = useAppSelector((state) => state.maps.duplicateMapType)
  const dryRunDuplicateFinished = useAppSelector(
    (state) => state.maps.dryRunDuplicateMapStatus === RequestStatus.Fulfilled
  )
  const duplicateMapFinished = useAppSelector((state) => state.maps.duplicateMapStatus === RequestStatus.Fulfilled)

  const duplicateMapConflicts = useMemo(() => {
    if (!dryRunDuplicateFinished) return false
    if (duplicateMapType === DuplicateMapType.Partial) {
      return true
    }
  }, [dryRunDuplicateFinished, duplicateMapType])

  useEffect(() => {
    if (connectionsStatus === RequestStatus.Idle && !isGuest) {
      dispatch(connectionsRequest())
    }
  }, [connectionsStatus, dispatch, isGuest])

  return { duplicatingMapId, dryRunDuplicateFinished, duplicateMapType, duplicateMapConflicts, duplicateMapFinished }
}
